<div id="Map-container">
  @if (loading()) {
    <div class="spinner-container">
      <app-spinner></app-spinner>
    </div>
  }
  <div class="inset-shadow-container"></div>
  <div
    class="find-devices-code"
    [class.mobile]="isMobile()"
    [class.tablet]="isTablet()"
    [class.desktop]="isDesktop()"
  >
    @if (isMobile()) {
      <div class="device-details">
        <div class="device-content-details first">
          <div (touchstart)="onSwipe($event, 'start')">
            <div class="device-content-icon">
              <i
                nz-icon
                [nzType]="isPanelOpen() ? 'line' : 'line'"
                class="svg-icon"
                alt="panel_open_icon"
              ></i>
            </div>
            <span class="body-bold" style="font-size: 20px">
              {{ i18n.langString("map_panel") }}
            </span>
          </div>

          @if (isPanelOpen()) {
            <div class="device-inner-content">
              <div class="inner-content-details">
                @for (plant of sortedPlantList(); track plant.objectID) {
                  <div class="one_row">
                    @if (plant["icon"] === "inactive") {
                      <i
                        nz-icon
                        class="svg_icon_inactive fillwhite"
                        [nzType]="'icons:' + plant['icon']"
                        alt="inactive_icon"
                      ></i>
                    }
                    @if (plant["icon"] === "critical") {
                      <i
                        nz-icon
                        class="svg_icon_critical fillwhite"
                        [nzType]="'icons:' + plant['icon']"
                        alt="critical_icon"
                      ></i>
                    }
                    @if (plant["icon"] === "warning") {
                      <i
                        nz-icon
                        class="svg_icon_warning"
                        [nzType]="'icons:' + plant['icon']"
                        alt="warning_icon"
                      ></i>
                    }
                    @if (plant["icon"] === "working") {
                      <i
                        nz-icon
                        class="svg_icon_working fillgreen"
                        [nzType]="'icons:' + plant['icon']"
                        alt="working_icon"
                      ></i>
                    }

                    <h3 class="plant_name">{{ plant.objectName }}</h3>

                    <div
                      class="clickable"
                      (click)="navigate(plant)"
                      (keydown.enter)="navigate(plant)"
                      tabindex="0"
                      role="button"
                      aria-label="View plant details"
                    >
                      <span
                        nz-icon
                        nzType="icons:arrow-right"
                        nzTheme="outline"
                      ></span>
                    </div>
                  </div>
                  <p class="sub_class">
                    {{ plant.Assets.length }}
                    {{ i18n.langString("equipments") }}
                  </p>
                  <p class="sub_class">
                    {{ plant.numSensors }} {{ i18n.langString("sensors") }}
                  </p>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (isDesktop()) {
      <nz-collapse class="colexppanel" [nzBordered]="false">
        <nz-collapse-panel
          [nzHeader]="i18n.langString('map_panel')"
          [nzActive]="isnzActive()"
          [nzExtra]="extraTpl"
          nzShowArrow="false"
          class="body-bold arrowBg"
          (nzActiveChange)="showArrow($event)"
        >
          <div class="separation-line"></div>
          <div class="device-inner-content">
            @for (plant of sortedPlantList(); track plant.objectID) {
              <div
                class="clickable"
                (click)="navigate(plant)"
                (keydown.enter)="navigate(plant)"
                tabindex="0"
                role="button"
                aria-label="View plant details"
              >
                <div class="one_row">
                  @if (plant["icon"] === "inactive") {
                    <i
                      nz-icon
                      class="svg_icon_inactive fillwhite"
                      [nzType]="'icons:' + plant['icon']"
                      alt="inactive_icon"
                    ></i>
                  }
                  @if (plant["icon"] === "critical") {
                    <i
                      nz-icon
                      class="svg_icon_critical fillwhite"
                      [nzType]="'icons:' + plant['icon']"
                      alt="critical_icon"
                    ></i>
                  }
                  @if (plant["icon"] === "warning") {
                    <i
                      nz-icon
                      class="svg_icon_warning"
                      [nzType]="'icons:' + plant['icon']"
                      alt="warning_icon"
                    ></i>
                  }
                  @if (plant["icon"] === "working") {
                    <i
                      nz-icon
                      class="svg_icon_working fillgreen"
                      [nzType]="'icons:' + plant['icon']"
                      alt="working_icon"
                    ></i>
                  }

                  <div class="plant_name">{{ plant.objectName }}</div>
                  <div class="right-arrow">
                    <span
                      nz-icon
                      nzType="icons:arrow-right"
                      nzTheme="outline"
                    ></span>
                  </div>
                </div>
                <p class="sub_class">
                  {{ plant.Assets.length }} {{ i18n.langString("equip") }}. /
                  {{ plant.numSensors }} {{ i18n.langString("sensors") }}
                </p>
              </div>
            }
          </div>
        </nz-collapse-panel>
      </nz-collapse>
    }
  </div>

  <ng-template #extraTpl>
    <div class="device-content-icon">
      <i
        nz-icon
        [nzType]="isnzActive() ? 'down' : 'up'"
        class="svg-icon"
        alt="up_down_icon"
      ></i>
    </div>
  </ng-template>

  <div id="Map"></div>
</div>
